import SiteEvents from '../util/site-events';

class Instagram {
	constructor($block) {
		this.$block = $block;
		this.$containerEl = this.$block.find('.block-instagram__container').first();

		if (!this.$containerEl.length) {
			return;
		}

		this.countLarge = parseInt(this.$containerEl.attr('data-count-large') || '', 10);
		this.countMedium = parseInt(this.$containerEl.attr('data-count-medium') || '', 10);
		this.countSmall = parseInt(this.$containerEl.attr('data-count-small') || '', 10);
		this.maxCount = Math.max(this.countLarge, this.countMedium, this.countSmall);

		this.loadFeed();
	}

	loadFeed() {
		jQuery
			.get('/wp-json/aq/v1/instagram-feed')
			.done((data) => {
				const columns = [];

				for (let i = 0; i < this.maxCount; i++) {
					if (!data[i]) {
						continue;
					}

					const colClasses = ['columns', 'small-12', 'medium-4', 'large-2'];

					if (i >= this.countSmall) {
						colClasses.push('hide-for-small-only');
					}

					if (i >= this.countMedium) {
						colClasses.push('hide-for-medium-only');
					}

					const imageUrl = data[i]?.thumbnail_url ?? data[i]?.media_url ?? '';
					const altText = data[i]?.caption ?? '';
					const permalink = data[i]?.permalink ?? '';

					columns.push(`
						<div class="${colClasses.join(' ')}">
							<a class="block-instagram__image-link" href="${permalink}" target="_blank" rel="noopener noreferrer">
								<img
									data-ib-sources="${imageUrl} 1080 1080"
									src="data:image/png;base64,iVBORw0KGgoAAAANSUhEUgAAAGQAAAABCAQAAACC0sM2AAAADElEQVR42mNkGCYAAAGSAAIVQ4IOAAAAAElFTkSuQmCC"
									alt="${altText}"
									class="block-instagram__image"
								>
							</a>
						</div>
					`);
				}

				this.$containerEl.append(columns.join(''));

				SiteEvents.imageBuddyUpdate();
			})
			.fail((err) => {
				console.error(err);

				this.$containerEl.append(`
					<div class="columns small-12 medium-8 align-middle">
						We're sorry, the Instagram feed cannot be retrieved at this time.
					</div>
				`);
			})
			.always(() => {});
	}
}

export default Instagram;
